import React from "react";
import { useTranslation } from "react-i18next";
import { useGoalEarnings } from "@/apps/goals/hooks/useGoalEarnings";
import { useWithdrawModalStore } from "@/apps/goals/store/withdrawModalStore";
import { useStartupParamsStore } from "@/store/startupParams";
import cls from "./styles.module.scss";

const RUBLE_SIGN = "\u20bd";

const formatMoney = (amount: number) =>
  new Intl.NumberFormat("ru-RU").format(amount);

export const WithdrawButton = () => {
  const { t } = useTranslation();
  const yandexId = useStartupParamsStore((state) => state.auth.yandexId);
  const openWithdrawModal = useWithdrawModalStore((state) => state.open);
  const { earnings } = useGoalEarnings(yandexId);
  const availableToWithdraw = earnings?.available_to_withdraw ?? 0;

  return (
    <button
      className={cls.trigger}
      type="button"
      onClick={openWithdrawModal}
      aria-label={t("goals.withdraw.ariaLabel", {
        amount: formatMoney(availableToWithdraw),
      })}
    >
      <img className={cls.coin} src="/goals/coin.png" alt="" />
      <span className={cls.amount}>
        {formatMoney(availableToWithdraw)} {RUBLE_SIGN}
      </span>
    </button>
  );
};
